import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, createSlots as _createSlots, Transition as _Transition, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "absolute top-0 right-4 z-10"
}
const _hoisted_2 = ["data-aria-sort", "onClick"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "relative tbody-container" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["id"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "absolute bottom-0 w-full h-[44px] bg-white pl-6 font-oswald text-[12.8px] text-zbr-gray-700 flex items-center border-y-2 border-zbr-gray-300"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 2,
  class: "pt-3 font-oswald text-sm text-center"
}
const _hoisted_11 = {
  key: 0,
  class: "absolute bottom-0 left-0 w-min min-w-full h-full flex items-center justify-center backdrop-blur z-40"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["id"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 0,
  class: "absolute bottom-0 w-full h-[44px] bg-white pl-6 font-oswald text-[12.8px] text-zbr-gray-700 flex items-center border-y-2 border-zbr-gray-300"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 2,
  class: "pt-3 font-oswald text-sm text-center"
}

import IconSort from '@/components/icons/IconSort.vue';
import IconInformationTransparent from '@/components/icons/IconInformationTransparent.vue';
import ScrollPagination from '@/components/ScrollPagination.vue';
import DynamicScrollerTable from '@/components/DynamicScrollerTable.vue';
import { ref, computed, watch, onMounted, shallowRef } from 'vue';
import { DynamicKeyValue } from '@/utils/types/index';
import { useDebounceFn, useResizeObserver } from '@vueuse/core';

import { useScreenSize } from '@/composables/useScreenSize';
import { useVehicleResultHelper } from '@/composables/useVehicleResultHelper';
import { useCalculationStore } from '@/stores/useCalculationStore';
import { storeToRefs } from 'pinia';
import {
  TyrePairItem,
  TyreBikeModelTyreItem,
  TyreItemResponse,
  TyreBargainItem,
  TyreDiscountItem,
  TyreAccessoryItem,
} from '@/utils/types/tyres';
import { RowsError, CombinationType } from '@/utils/types/baseTableType';
import { VProgressLinear } from 'vuetify/components/VProgressLinear';

interface BaseTableField {
  text: string;
  value: string;
  align?: string;
  flexJustify?: string;
  sortable?: boolean;
  isAction?: boolean;
  minWidth: {
    tablet?: string;
    desktop?: string;
    desktopLg?: string;
  };
  maxWidth: {
    tablet?: string;
    desktop?: string;
    desktopLg?: string;
  };
  colSpan?: string;
  isHiddenTextMobile?: boolean;
  noPaddingLeft?: boolean;
}
interface RowClickEvent {
  tableItem: DynamicKeyValue;
  index: number;
}
interface ToggleTableRowExpandEvent {
  tableItem: DynamicKeyValue;
  index: number;
  expandRowStatus: boolean | undefined;
}
interface SortStatus {
  [key: string]: string;
}
interface ExpandStatus {
  [key: string]: boolean | undefined;
}
interface ShowRowMoreInfo {
  [key: string]: boolean | undefined;
}
/**
 * Props
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'BaseTable',
  props: {
    tableFieldsTablet: { default: () => [] },
    tableFieldsTabletMoreInfo: { default: () => [] },
    tableFields: { default: () => [] },
    tableItems: { default: () => [] },
    clickable: { type: Boolean, default: true },
    expandColSpan: { default: '' },
    isHideHeader: { type: Boolean, default: false },
    tableClass: { default: '' },
    tableBodyClass: { default: '' },
    inverse: { type: Boolean, default: false },
    scrollable: { type: Boolean, default: true },
    scrollOptimize: { type: Boolean, default: false },
    scrollOptimizeKeyField: { default: 'articleNo' },
    maxHeight: { default: '' },
    isPageEnd: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    isCombination: { type: Boolean, default: false },
    hasPaddingLeft: { type: Boolean, default: true },
    customPaddingLeft: { default: '' },
    customPaddingRight: { default: '' },
    alwaysShowMoreInfo: { type: Boolean, default: false },
    isInitOpenShowMoreInfo: { type: Boolean, default: false },
    hasRowTitle: { type: Boolean, default: false },
    hasRowTitleTablet: { type: Boolean, default: false },
    rowsTableError: { default: undefined },
    isVehicleSearch: { type: Boolean, default: false },
    showAllField: { type: Boolean, default: false },
    hasCloseAllShowMoreInfo: { type: Boolean, default: false },
    addToCartPopup: { type: Boolean, default: false },
    combinationType: { default: undefined },
    customGap: { default: '' }
  },
  emits: ["on-sort", "row-click", "next-page", "toggle-table-row-expand", "close-table-row-expand", "toggle-row-more-info", "close-all-show-row-more-info"],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;


/**
 * Emits
 */


/**
 * States
 */
const { isTablet, isDesktop } = useScreenSize();
const { isNoInfoAndArticleAA, isNoInfoAndArticle88, isArticle88, isArticle99 } =
  useVehicleResultHelper();
const calculationStore = useCalculationStore();
const { isCalculationTax } = storeToRefs(calculationStore);

const activeSortCol = ref('');
const sortColStatus = shallowRef({} as SortStatus);
const expandRowStatus = shallowRef({} as ExpandStatus);
const expandRowStatusFront = shallowRef({} as ExpandStatus);
const expandRowStatusRear = shallowRef({} as ExpandStatus);
const showRowMoreInfo = shallowRef({} as ShowRowMoreInfo);
const showRowMoreInfoFront = shallowRef({} as ShowRowMoreInfo);
const showRowMoreInfoRear = shallowRef({} as ShowRowMoreInfo);
const scrollPaginationRef = ref(null);
const dynamicScrollerTableRef = ref<InstanceType<typeof DynamicScrollerTable> | null>(null);
const scrollWrapperEl = ref<HTMLElement | null>(null);
const isSelectCloseAllInfo = ref(false);

/**
 * Computed
 */
const computedTableFields = computed(() => {
  if (
    isTablet.value &&
    props.tableFieldsTablet &&
    props.tableFieldsTablet.length > 0
  ) {
    return props.tableFieldsTablet;
  }
  return props.tableFields;
});
const getSortableFields = computed(() =>
  props.tableFields.filter((item) => item.sortable),
);
const hasInfoFieldDesktop = computed(() =>
  props.tableFields.some((item) => item.value === 'info'),
);
const getGridTemplateColumnsMdVar = computed(() => {
  let result = '';
  props.tableFields.forEach((item, index) => {
    if (index === 0) {
      result += `minmax(${item.minWidth.desktop}, ${item.maxWidth.desktop})`;
    } else {
      result +=
        ' ' + `minmax(${item.minWidth.desktop}, ${item.maxWidth.desktop})`;
    }
  });
  return {
    '--table-grid-template-columns-xl': result,
  };
});

const getGridTemplateColumnsLgVar = computed(() => {
  let result = '';
  props.tableFields.forEach((item, index) => {
    if (index === 0) {
      result += `minmax(${item.minWidth.desktopLg}, ${item.maxWidth.desktopLg})`;
    } else {
      result +=
        ' ' + `minmax(${item.minWidth.desktopLg}, ${item.maxWidth.desktopLg})`;
    }
  });
  return {
    '--table-grid-template-columns-2xl': result,
  };
});
const getGridTemplateColumn: DynamicKeyValue = computed(() => {
  if (isTablet.value) {
    return {};
  }
  return {
    ...getGridTemplateColumnsMdVar.value,
    ...getGridTemplateColumnsLgVar.value,
  };
});
const getGridTemplateColumnTablet: DynamicKeyValue = computed(() => {
  if (!isTablet.value) {
    return {};
  }
  let result = '';
  if (props.tableFieldsTablet) {
    props.tableFieldsTablet.forEach((item, index) => {
      if (index === 0) {
        result += `minmax(${item.minWidth.tablet}, ${item.maxWidth.tablet})`;
      } else {
        result +=
          ' ' + `minmax(${item.minWidth.tablet}, ${item.maxWidth.tablet})`;
      }
    });
  }
  return {
    '--table-grid-template-columns-tablet': result,
  };
});
const tableItemLength = computed(() => props.tableItems.length);
const isOverflownY = ref(false);

const checkOverflow = useDebounceFn(() => {
  if (scrollWrapperEl.value) {
    isOverflownY.value =
      scrollWrapperEl.value.scrollHeight > scrollWrapperEl.value.clientHeight;
  }
}, 100);

useResizeObserver(scrollWrapperEl, checkOverflow);

onMounted(() => {
  scrollWrapperEl.value = document.getElementById('baseTableScroll');
  checkOverflow();
});

// Watch
watch([isDesktop, tableItemLength], () => {
  setInitExpandRowStatus();
  setInitShowRowMoreInfo();
});

watch(
  () => props.isLoading,
  (val) => {
    if (!val) {
      scrollWrapperEl.value = document.getElementById('baseTableScroll');
    }
  },
);

setInitExpandRowStatus();
setInitShowRowMoreInfo();

function setInitExpandRowStatus() {
  if (props.tableItems.length === 0) {
    return;
  }
  const initExpandRowStatus: ExpandStatus = {};
  props.tableItems.forEach((item, index) => {
    initExpandRowStatus[index] = false;
  });
  expandRowStatus.value = initExpandRowStatus;
  expandRowStatusFront.value = { ...initExpandRowStatus };
  expandRowStatusRear.value = { ...initExpandRowStatus };
}

function setInitShowRowMoreInfo() {
  if (props.tableItems.length === 0) {
    return;
  }
  const initShowRowMoreInfo: ShowRowMoreInfo = {};
  const defaultValue = props.alwaysShowMoreInfo
    ? props.alwaysShowMoreInfo
    : isSelectCloseAllInfo.value
      ? false
      : props.isInitOpenShowMoreInfo || false;

  props.tableItems.forEach((item, index) => {
    initShowRowMoreInfo[index] = defaultValue;
  });
  showRowMoreInfo.value = initShowRowMoreInfo;
  showRowMoreInfoFront.value = { ...initShowRowMoreInfo };
  showRowMoreInfoRear.value = { ...initShowRowMoreInfo };
}
function closeAllShowRowMoreInfo() {
  if (props.tableItems.length === 0) {
    return;
  }

  // If using scrollOptimize, call closeAllShowMoreInfo on DynamicScrollerTable
  if (props.scrollOptimize && dynamicScrollerTableRef.value) {
    dynamicScrollerTableRef.value.closeAllShowMoreInfo();
  }

  const showRowMoreInfoStatus: ShowRowMoreInfo = {};
  isSelectCloseAllInfo.value = true;
  props.tableItems.forEach((item, index) => {
    showRowMoreInfoStatus[index] = false;
  });
  showRowMoreInfo.value = showRowMoreInfoStatus;
  showRowMoreInfoFront.value = { ...showRowMoreInfoStatus };
  showRowMoreInfoRear.value = { ...showRowMoreInfoStatus };
  emit('close-all-show-row-more-info');
}

/**
 * On clicking sort column
 * @param selectedColField
 */
function onSort(selectedColField: BaseTableField) {
  if (!selectedColField.sortable || props.tableItems.length === 0) {
    return;
  }
  const currentStatus = sortColStatus.value[selectedColField.value];
  let newStatus = '';
  if (currentStatus === 'none') {
    newStatus = 'asc';
  } else if (currentStatus === 'asc') {
    newStatus = 'desc';
  } else if (currentStatus === 'desc') {
    newStatus = 'none';
  }
  const newSortColStatus: SortStatus = {};
  getSortableFields.value.forEach((field) => {
    newSortColStatus[field.value] =
      selectedColField.value === field.value ? newStatus : 'none';
  });
  sortColStatus.value = newSortColStatus;
  activeSortCol.value = selectedColField.value.includes('tablet-')
    ? selectedColField.value.toString().replace('tablet-', '')
    : selectedColField.value;
  const isPriceColumn =
    activeSortCol.value === 'calculationBasisPrice' ||
    activeSortCol.value === 'purchasingPrice' ||
    activeSortCol.value === 'reductionPrice' ||
    activeSortCol.value === 'salePrice';

  const sortColumn = isPriceColumn
    ? 'price.' + activeSortCol.value.toString().replace('Price', '')
    : activeSortCol.value;
  emit('on-sort', {
    activeSortCol: sortColumn,
    status: newStatus,
  });
}

function onClickTableRow(
  tableItem: DynamicKeyValue,
  index: number,
  axis?: string,
) {
  if (!props.clickable) {
    return;
  }

  if (tableItem.disableClickTableRow) {
    return;
  }

  emit('row-click', {
    tableItem,
    index,
  });
  toggleTableRowExpand(tableItem, index, axis);
}

function getRowClass(index: number) {
  if (props.inverse) {
    if (index % 2 === 1) {
      return 'bg-zbr-gray-300';
    } else {
      return 'bg-white';
    }
  } else {
    if (index % 2 === 1) {
      return 'bg-white';
    } else {
      return 'bg-zbr-gray-300';
    }
  }
}

function toggleRowMoreInfo(index: number, axis?: string) {
  if (props.alwaysShowMoreInfo) {
    return;
  }
  if (!props.isCombination) {
    showRowMoreInfo.value = {
      ...showRowMoreInfo.value,
      [index]: !showRowMoreInfo.value[index],
    };
    emit('toggle-row-more-info');
    return;
  }

  if (axis === 'front') {
    showRowMoreInfoFront.value = {
      ...showRowMoreInfoFront.value,
      [index]: !showRowMoreInfoFront.value[index],
    };
    emit('toggle-row-more-info');
  } else {
    showRowMoreInfoRear.value = {
      ...showRowMoreInfoRear.value,
      [index]: !showRowMoreInfoRear.value[index],
    };
    emit('toggle-row-more-info');
  }
}
function toggleTableRowExpand(
  tableItem: DynamicKeyValue,
  index: number,
  axis?: string,
) {
  if (!props.isCombination) {
    expandRowStatus.value = {
      ...expandRowStatus.value,
      [index]: !expandRowStatus.value[index],
    };
    emit('toggle-table-row-expand', {
      tableItem,
      index,
      expandRowStatus: expandRowStatus.value[index] || false,
    });
    return;
  }
  if (axis === 'front') {
    expandRowStatusFront.value = {
      ...expandRowStatusFront.value,
      [index]: !expandRowStatusFront.value[index],
    };
    emit('toggle-table-row-expand', {
      tableItem,
      index,
      expandRowStatus: expandRowStatusFront.value[index] || false,
    });
  } else {
    expandRowStatusRear.value = {
      ...expandRowStatusRear.value,
      [index]: !expandRowStatusRear.value[index],
    };
    emit('toggle-table-row-expand', {
      tableItem,
      index,
      expandRowStatus: expandRowStatusRear.value[index] || false,
    });
  }
}

function closeTableRowExpand(index: number, axis?: string) {
  if (!props.isCombination) {
    expandRowStatus.value = {
      ...expandRowStatus.value,
      [index]: false,
    };
    emit('close-table-row-expand');
    return;
  }
  if (axis === 'front') {
    expandRowStatusFront.value = {
      ...expandRowStatusFront.value,
      [index]: false,
    };
    emit('close-table-row-expand');
  } else {
    expandRowStatusRear.value = {
      ...expandRowStatusRear.value,
      [index]: false,
    };
    emit('close-table-row-expand');
  }
}
function isNoLongerProducedProduct(
  item:
    | TyrePairItem
    | TyreBikeModelTyreItem
    | TyreItemResponse
    | TyreBargainItem
    | TyreDiscountItem
    | TyreAccessoryItem,
  axis?: 'front' | 'rear',
) {
  if (item === undefined || props.showAllField) {
    return false;
  }
  let tyreItem;
  if (!axis) {
    tyreItem = item as
      | TyreItemResponse
      | TyreBargainItem
      | TyreDiscountItem
      | TyreAccessoryItem;
    return (
      tyreItem.articleNo === '8888888888' || tyreItem.articleNo === '9999999999'
    );
  }

  if (Object.keys(item).includes('tyres')) {
    tyreItem = item as TyreBikeModelTyreItem;
    return (
      tyreItem.tyres[axis].articleNo === '8888888888' ||
      tyreItem.tyres[axis].articleNo === '9999999999'
    );
  }

  tyreItem = item as TyrePairItem;
  return (
    tyreItem[axis].articleNo === '8888888888' ||
    tyreItem[axis].articleNo === '9999999999'
  );
}

function isPairTyreShowCart(item: TyrePairItem | TyreBikeModelTyreItem) {
  if (item === undefined || props.showAllField) {
    return false;
  }

  let tyreItem;
  if (Object.keys(item).includes('tyres')) {
    tyreItem = item as TyreBikeModelTyreItem;
    return (
      (tyreItem.tyres.front.comments.includes('TOOLS-NO-PRODUCTION-2022') ||
        tyreItem.tyres.front.articleNo === '8888888888' ||
        tyreItem.tyres.front.articleNo === '9999999999') &&
      (tyreItem.tyres.rear.comments.includes('TOOLS-NO-PRODUCTION-2022') ||
        tyreItem.tyres.rear.articleNo === '8888888888' ||
        tyreItem.tyres.rear.articleNo === '9999999999')
    );
  }

  tyreItem = item as TyrePairItem;
  return (
    (tyreItem.front.comments.includes('TOOLS-NO-PRODUCTION-2022') ||
      tyreItem.front.articleNo === '8888888888' ||
      tyreItem.front.articleNo === '9999999999') &&
    (tyreItem.rear.comments.includes('TOOLS-NO-PRODUCTION-2022') ||
      tyreItem.rear.articleNo === '8888888888' ||
      tyreItem.rear.articleNo === '9999999999')
  );
}

function isCommentNoProduction(
  item:
    | TyrePairItem
    | TyreBikeModelTyreItem
    | TyreItemResponse
    | TyreBargainItem
    | TyreDiscountItem
    | TyreAccessoryItem,
  axis?: 'front' | 'rear',
) {
  if (item === undefined || props.showAllField) {
    return false;
  }
  let tyreItem;
  if (!axis) {
    tyreItem = item as
      | TyreItemResponse
      | TyreBargainItem
      | TyreDiscountItem
      | TyreAccessoryItem;
    return (
      tyreItem.comments &&
      tyreItem.comments.length &&
      tyreItem.comments.includes('TOOLS-NO-PRODUCTION-2022')
    );
  }

  if (Object.keys(item).includes('tyres')) {
    tyreItem = item as TyreBikeModelTyreItem;
    return (
      tyreItem.tyres[axis].comments &&
      tyreItem.tyres[axis].comments.length &&
      tyreItem.tyres[axis].comments.includes('TOOLS-NO-PRODUCTION-2022')
    );
  }

  tyreItem = item as TyrePairItem;
  return (
    tyreItem[axis].comments &&
    tyreItem[axis].comments.length &&
    tyreItem[axis].comments.includes('TOOLS-NO-PRODUCTION-2022')
  );
}
function isProduct99(
  item:
    | TyrePairItem
    | TyreBikeModelTyreItem
    | TyreItemResponse
    | TyreBargainItem
    | TyreDiscountItem
    | TyreAccessoryItem,
  axis?: 'front' | 'rear',
) {
  if (item === undefined || props.showAllField) {
    return false;
  }
  let tyreItem;
  if (!axis) {
    tyreItem = item as
      | TyreItemResponse
      | TyreBargainItem
      | TyreDiscountItem
      | TyreAccessoryItem;
    return isArticle99(tyreItem);
  }

  if (Object.keys(item).includes('tyres')) {
    tyreItem = item as TyreBikeModelTyreItem;
    return isArticle99(tyreItem.tyres[axis]);
  }

  tyreItem = item as TyrePairItem;
  return isArticle99(tyreItem[axis]);
}
function isProduct88(
  item:
    | TyrePairItem
    | TyreBikeModelTyreItem
    | TyreItemResponse
    | TyreBargainItem
    | TyreDiscountItem
    | TyreAccessoryItem,
  axis?: 'front' | 'rear',
) {
  if (item === undefined || props.showAllField) {
    return false;
  }
  let tyreItem;
  if (!axis) {
    tyreItem = item as
      | TyreItemResponse
      | TyreBargainItem
      | TyreDiscountItem
      | TyreAccessoryItem;
    return isArticle88(tyreItem);
  }

  if (Object.keys(item).includes('tyres')) {
    tyreItem = item as TyreBikeModelTyreItem;
    return isArticle88(tyreItem.tyres[axis]);
  }

  tyreItem = item as TyrePairItem;
  return isArticle88(tyreItem[axis]);
}

function isNoStock(
  item:
    | TyrePairItem
    | TyreBikeModelTyreItem
    | TyreItemResponse
    | TyreBargainItem
    | TyreDiscountItem
    | TyreAccessoryItem,
  axis?: 'front' | 'rear',
) {
  if (item === undefined || props.showAllField) {
    return false;
  }
  let tyreItem;
  if (!axis) {
    tyreItem = item as
      | TyreItemResponse
      | TyreBargainItem
      | TyreDiscountItem
      | TyreAccessoryItem;
    return tyreItem.stock === 0;
  }

  if (Object.keys(item).includes('tyres')) {
    tyreItem = item as TyreBikeModelTyreItem;
    return tyreItem.tyres[axis].stock === 0;
  }

  tyreItem = item as TyrePairItem;
  return tyreItem[axis].stock === 0;
}

function isVehicleSearchDisableClickRow(
  item: any,
  axis: 'front' | 'rear',
): boolean {
  let tableItem;
  if (Object.keys(item).includes('tyres')) {
    tableItem = item.tyres[axis];
  } else {
    tableItem = item[axis];
  }

  return (
    !!props.isVehicleSearch &&
    (isNoInfoAndArticleAA(tableItem) || isNoInfoAndArticle88(tableItem))
  );
}

const onNextPage = useDebounceFn((e: number) => emit('next-page', e), 100);

function isPremiumCombinationTyres(tableItem: any) {
  if (!props.combinationType) {
    return false;
  }
  if (props.combinationType === 'vehicleSearch') {
    return tableItem.tyres.front.isPremium && tableItem.tyres.rear.isPremium;
  }
  if (props.combinationType === 'tyreSearch') {
    return tableItem.front.isPremium && tableItem.rear.isPremium;
  }
}

__expose({
  scrollPaginationRef,
  dynamicScrollerTableRef,
});

const initSortStatus: SortStatus = {};
getSortableFields.value.forEach((field) => {
  initSortStatus[field.value] = 'none';
});
sortColStatus.value = initSortStatus;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'base-table relative h-full overflow-x-auto overflow-y-hidden',
      _ctx.tableClass,
    ]),
    style: _normalizeStyle({
      ...getGridTemplateColumn.value,
      ...getGridTemplateColumnTablet.value,
    })
  }, [
    (_unref(isTablet) && _ctx.hasCloseAllShowMoreInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("button", {
            class: "flex items-center h-zbr-medium px-[11px] border border-zbr-gray-300 text-zbr-gray-700 bg-white text-[13px] hover:text-zbr-primary hover:bg-zbr-primary-50 transition-all duration-200",
            onClick: closeAllShowRowMoreInfo
          }, _toDisplayString(_ctx.$t("HIDE-ALL-INFO")), 1)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isHideHeader)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([
        'thead-row relative grid grid-cols-base-table-tablet items-end w-full border-b-2 border-zbr-gray-300',
        'xl:grid-cols-base-table-xl',
        '2xl:grid-cols-base-table-2xl',
        isOverflownY.value ? 'pr-[6px]' : null,
        _ctx.inverse ? 'bg-zbr-gray-50' : null,
        _ctx.hasPaddingLeft
          ? _ctx.customPaddingLeft
            ? _ctx.customPaddingLeft
            : 'pl-6'
          : null,
        _ctx.customPaddingRight ? _ctx.customPaddingRight : null,
        _ctx.customGap ? _ctx.customGap : null,
      ])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(computedTableFields.value, (field, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `virtualTableHeadTh${index}`,
              class: _normalizeClass([
          'th relative font-oswald text-[12.8px] text-zbr-gray-700',
          _unref(isTablet) && _ctx.hasCloseAllShowMoreInfo
            ? 'pt-[18px] pb-[10px]'
            : 'py-[10px]',
          _ctx.tableItems.length === 0
            ? 'pointer-events-none'
            : 'pointer-events-auto',
          field.sortable ? 'sortable-field' : 'cursor-auto',
          field.align,
          field.flexJustify,
          field.value,
          field.colSpan ? field.colSpan : '',
        ]),
              "data-aria-sort": [field.sortable ? sortColStatus.value[field.value] : null],
              onClick: ($event: any) => (onSort(field))
            }, [
              _createElementVNode("span", {
                class: _normalizeClass([
            'th-text relative',
            ['asc', 'desc'].includes(sortColStatus.value[field.value])
              ? 'text-zbr-primary'
              : null,
            field.sortable ? 'select-none mr-1' : null,
          ])
              }, [
                (_ctx.$slots[`th(${field.value})`])
                  ? _renderSlot(_ctx.$slots, `th(${field.value})`, {
                      key: 0,
                      item: field
                    })
                  : (field.value === 'salePrice')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_unref(isCalculationTax) ? _ctx.$t("VK-INCL-TAX") : _ctx.$t("VK-NET")), 1)
                      ], 64))
                    : (_ctx.$t(field.text).includes('\<\/'))
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 2,
                          innerHTML: _ctx.$t(field.text)
                        }, null, 8, _hoisted_3))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          _createTextVNode(_toDisplayString(_ctx.$t(field.text)), 1)
                        ], 64))
              ], 2),
              (field.sortable)
                ? (_openBlock(), _createBlock(IconSort, {
                    key: 0,
                    sort: sortColStatus.value[field.value]
                  }, null, 8, ["sort"]))
                : _createCommentVNode("", true)
            ], 10, _hoisted_2))
          }), 128)),
          (_ctx.scrollable && _ctx.isLoading)
            ? (_openBlock(), _createBlock(_unref(VProgressLinear), {
                key: 0,
                class: "absolute !top-full left-0 w-full z-40",
                indeterminate: "",
                color: "var(--color-primary)"
              }))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.scrollable && _ctx.isLoading && _ctx.isHideHeader)
      ? (_openBlock(), _createBlock(_unref(VProgressLinear), {
          key: 2,
          class: "absolute top-0 left-0 w-full z-40",
          indeterminate: "",
          color: "var(--color-primary)"
        }))
      : _createCommentVNode("", true),
    (_ctx.scrollable && !_ctx.scrollOptimize)
      ? (_openBlock(), _createBlock(ScrollPagination, {
          key: 3,
          ref_key: "scrollPaginationRef",
          ref: scrollPaginationRef,
          "scroll-id": "baseTableScroll",
          "max-height": _ctx.maxHeight,
          "is-loading": _ctx.isLoading,
          "is-page-end": _ctx.isPageEnd,
          onNextPage: _unref(onNextPage)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _renderSlot(_ctx.$slots, "bodyPrepend"),
              (!_ctx.isCombination)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.tableItems, (tableItem, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `tableItem${index}`,
                      class: _normalizeClass([
              'relative tbody-tr grid grid-cols-base-table-tablet items-center w-full min-h-[52px] group hover:bg-zbr-primary-50',
              'xl:grid-cols-base-table-xl',
              '2xl:grid-cols-base-table-2xl',
              getRowClass(index),
              _ctx.hasPaddingLeft
                ? _ctx.customPaddingLeft
                  ? _ctx.customPaddingLeft
                  : 'pl-6'
                : null,
              _ctx.customPaddingRight ? _ctx.customPaddingRight : null,
              _ctx.customGap ? _ctx.customGap : null,
              _ctx.clickable && hasInfoFieldDesktop.value ? 'group' : null,
              _ctx.rowsTableError && _ctx.rowsTableError[index] ? '!bg-red-100' : null,
              tableItem.isPremium ? 'is-premium-tyre' : '',
            ])
                    }, [
                      (_ctx.clickable && hasInfoFieldDesktop.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "hidden xl:block absolute w-full h-full click-area z-[1]",
                            onClick: ($event: any) => (onClickTableRow(tableItem, index))
                          }, null, 8, _hoisted_5))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(computedTableFields.value, (field, fieldIndex) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `virtualTableBodyTdDesktop${index}${fieldIndex}-${field.value}`,
                          class: _normalizeClass([
                'table-body-data flex items-center min-h-[52px] group-hover:bg-zbr-primary-50',
                _ctx.tableBodyClass ? _ctx.tableBodyClass : 'text-sm',
                field.value === 'cart' ? 'h-full justify-center' : null,
                field.isAction ? 'relative z-10' : null,
                getRowClass(index),
                field.align,
                field.flexJustify,
                field.value,
                _ctx.rowsTableError && _ctx.rowsTableError[index] ? '!bg-red-100' : null,
              ])
                        }, [
                          (
                  [
                    'quantity',
                    'cart',
                    'price',
                    'info',
                    'calculationBasisPrice',
                    'salePrice',
                    'purchasingPrice',
                    'reductionPrice',
                  ].includes(field.value) &&
                    isNoLongerProducedProduct(tableItem)
                )
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
                            : (
                  ['quantity', 'cart'].includes(field.value.toLowerCase()) &&
                    isCommentNoProduction(tableItem) &&
                    tableItem.stock === 0
                )
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [], 64))
                              : (
                  (isProduct88(tableItem) || isProduct99(tableItem)) &&
                    field.value.toLowerCase() === 'availability'
                )
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [], 64))
                                : (
                  (isProduct88(tableItem) || isProduct99(tableItem)) &&
                    field.value.toLowerCase() === 'image'
                )
                                  ? (_openBlock(), _createBlock(IconInformationTransparent, {
                                      key: 3,
                                      style: {"margin-left":"10px"}
                                    }))
                                  : (_ctx.$slots[`td(${field.value})`])
                                    ? _renderSlot(_ctx.$slots, `td(${field.value})`, {
                                        key: 4,
                                        item: tableItem,
                                        index: index,
                                        value: tableItem[field.value],
                                        toggleExpandRow: 
                  () => toggleTableRowExpand(tableItem, index)
                ,
                                        toggleRowMoreInfo: () => toggleRowMoreInfo(index),
                                        expandRowStatus: expandRowStatus.value[index],
                                        showRowMoreInfo: showRowMoreInfo.value[index]
                                      })
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                        _createTextVNode(_toDisplayString(tableItem[field.value]), 1)
                                      ], 64))
                        ], 2))
                      }), 128)),
                      (_unref(isTablet) && showRowMoreInfo.value[index])
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.tableFieldsTabletMoreInfo, (field, fieldIndex) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: `virtualTableBodyTdTabletMoreInfo${index}${fieldIndex}`,
                              class: _normalizeClass([
                  'table-body-data flex items-center h-[68px] border-zbr-gray-300 border-t',
                  _ctx.tableBodyClass ? _ctx.tableBodyClass : 'text-sm',
                  field.value === 'cart' ? 'h-full justify-center' : null,
                  field.isAction ? 'relative z-10' : null,
                  field.colSpan ? field.colSpan : '',
                  field.align,
                  field.flexJustify,
                  field.value,
                  _ctx.rowsTableError && _ctx.rowsTableError[index]
                    ? '!bg-red-100'
                    : null,
                ])
                            }, [
                              _renderSlot(_ctx.$slots, `td(${field.value}TabletMore)`, {
                                item: tableItem,
                                index: index,
                                value: tableItem[field.value]
                              })
                            ], 2))
                          }), 128))
                        : _createCommentVNode("", true),
                      (expandRowStatus.value[index] || tableItem.isExpand)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: _normalizeClass([
                'table-expand relative z-10 row-end-auto min-h-[52px] z-[21]',
                _ctx.expandColSpan,
              ])
                          }, [
                            _renderSlot(_ctx.$slots, "tdExpand", {
                              item: tableItem,
                              index: index,
                              closeExpandRow: () => closeTableRowExpand(index)
                            })
                          ], 2))
                        : _createCommentVNode("", true)
                    ], 2))
                  }), 128))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.tableItems, (tableItem, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `tableItemFront${index}`,
                      id: `group-tr-${index}`,
                      class: _normalizeClass([
                'relative hover:bg-zbr-primary-50',
                getRowClass(index),
                isPremiumCombinationTyres(tableItem) ? 'is-premium-tyre' : '',
              ])
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass([
                  'relative tbody-tr grid grid-cols-base-table-tablet items-center w-full min-h-[52px]',
                  'xl:grid-cols-base-table-xl',
                  '2xl:grid-cols-base-table-2xl',
                  _ctx.hasPaddingLeft
                    ? _ctx.customPaddingLeft
                      ? _ctx.customPaddingLeft
                      : 'pl-6'
                    : null,
                  _ctx.customPaddingRight ? _ctx.customPaddingRight : null,
                  _ctx.customGap ? _ctx.customGap : null,
                  _ctx.clickable &&
                    hasInfoFieldDesktop.value &&
                    !isVehicleSearchDisableClickRow(tableItem, 'front')
                    ? 'group'
                    : null,
                  _ctx.rowsTableError && _ctx.rowsTableError[index]
                    ? '!bg-red-100'
                    : null,
                ])
                      }, [
                        (
                    _ctx.clickable &&
                      hasInfoFieldDesktop.value &&
                      !isVehicleSearchDisableClickRow(tableItem, 'front')
                  )
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "hidden xl:block absolute w-full h-full click-area z-[1]",
                              onClick: ($event: any) => (onClickTableRow(tableItem, index, 'front'))
                            }, null, 8, _hoisted_7))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(computedTableFields.value, (field, fieldIndex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `virtualTableBodyTd${index}${fieldIndex}${computedTableFields.value.length}`,
                            class: _normalizeClass([
                    'table-body-data flex items-center min-h-[52px]',
                    _ctx.tableBodyClass ? _ctx.tableBodyClass : 'text-sm',
                    field.value === 'favourite' || field.value === 'cart'
                      ? 'h-full justify-center'
                      : null,
                    field.colSpan ? field.colSpan : '',
                    field.value === 'cart' && showRowMoreInfoFront.value[index]
                      ? '-col-start-1 row-span-4'
                      : field.value === 'cart'
                        ? '-col-start-1 row-span-2 z-20'
                        : '',
                    field.value === 'favourite' && showRowMoreInfoFront.value[index]
                      ? 'col-start-1 row-span-4'
                      : field.value === 'favourite'
                        ? 'col-start-1 row-span-2'
                        : '',
                    field.isAction ? 'relative z-20' : null,
                    field.align,
                    field.flexJustify,
                    field.value,
                    _ctx.rowsTableError && _ctx.rowsTableError[index]
                      ? '!bg-red-100'
                      : null,
                  ])
                          }, [
                            (
                      [
                        'quantity',
                        'price',
                        'info',
                        'quantityFront',
                        'priceFront',
                        'infoFront',
                        'calculationBasisPrice',
                        'salePrice',
                        'purchasingPrice',
                        'reductionPrice',
                      ].includes(field.value) &&
                        isNoLongerProducedProduct(tableItem, 'front')
                    )
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
                              : (
                      ['quantity', 'quantityFront'].includes(
                        field.value.toLowerCase()
                      ) &&
                        isCommentNoProduction(tableItem, 'front') &&
                        isNoStock(tableItem, 'front')
                    )
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [], 64))
                                : (
                      ['cart', 'cartFront'].includes(
                        field.value.toLowerCase()
                      ) &&
                        isPairTyreShowCart(tableItem) &&
                        isNoLongerProducedProduct(tableItem, 'front') &&
                        isNoLongerProducedProduct(tableItem, 'rear')
                    )
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [], 64))
                                  : (
                      ['cart', 'cartFront'].includes(
                        field.value.toLowerCase()
                      ) &&
                        isPairTyreShowCart(tableItem) &&
                        isCommentNoProduction(tableItem, 'front') &&
                        isNoStock(tableItem, 'front') &&
                        isCommentNoProduction(tableItem, 'rear') &&
                        isNoStock(tableItem, 'rear')
                    )
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [], 64))
                                    : (
                      (isProduct88(tableItem, 'front') ||
                        isProduct99(tableItem, 'front')) &&
                        ['availability', 'availabilityFront'].includes(
                          field.value.toLowerCase()
                        )
                    )
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [], 64))
                                      : (
                      (isProduct88(tableItem, 'front') ||
                        isProduct99(tableItem, 'front')) &&
                        ['image', 'imageFront'].includes(
                          field.value.toLowerCase()
                        )
                    )
                                        ? (_openBlock(), _createBlock(IconInformationTransparent, {
                                            key: 5,
                                            style: {"margin-left":"10px"}
                                          }))
                                        : (field.value === 'cart')
                                          ? _renderSlot(_ctx.$slots, "td(cart)", {
                                              key: 6,
                                              item: tableItem,
                                              index: index,
                                              value: tableItem['cart']
                                            })
                                          : (_ctx.$slots[`td(${field.value}Front)`])
                                            ? _renderSlot(_ctx.$slots, `td(${field.value}Front)`, {
                                                key: 7,
                                                item: tableItem,
                                                index: index,
                                                value: tableItem[field.value],
                                                toggleExpandRow: 
                      () => toggleTableRowExpand(tableItem, index, 'front')
                    ,
                                                toggleRowMoreInfo: 
                      () => toggleRowMoreInfo(index, 'front')
                    ,
                                                expandRowStatus: expandRowStatusFront.value[index],
                                                showRowMoreInfo: showRowMoreInfoFront.value[index]
                                              })
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                                                _createTextVNode(_toDisplayString(tableItem[field.value]), 1)
                                              ], 64))
                          ], 2))
                        }), 128)),
                        (_unref(isTablet) && showRowMoreInfoFront.value[index])
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.tableFieldsTabletMoreInfo, (field, fieldIndex) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: `virtualTableBodyTdTabletMoreFront${index}${fieldIndex}`,
                                class: _normalizeClass([
                      'table-body-data flex items-center h-[68px] border-zbr-gray-300 border-b',
                      _ctx.tableBodyClass ? _ctx.tableBodyClass : 'text-sm',
                      field.value === 'cart' ? 'h-full justify-center' : null,
                      field.colSpan ? field.colSpan : '',
                      field.isAction ? 'relative z-10' : null,
                      field.align,
                      field.flexJustify,
                      field.value,
                      _ctx.rowsTableError && _ctx.rowsTableError[index]
                        ? '!bg-red-100'
                        : null,
                    ])
                              }, [
                                _renderSlot(_ctx.$slots, `td(${field.value}TabletMoreFront)`, {
                                  item: tableItem,
                                  index: index,
                                  value: tableItem[field.value]
                                })
                              ], 2))
                            }), 128))
                          : _createCommentVNode("", true)
                      ], 2),
                      (expandRowStatusFront.value[index] || tableItem.isExpand)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass([
                  'table-expand relative z-10 min-h-[52px] z-[21]',
                  _ctx.expandColSpan,
                ])
                          }, [
                            _renderSlot(_ctx.$slots, "tdExpandFront", {
                              item: tableItem,
                              index: index,
                              closeExpandRow: () => closeTableRowExpand(index, 'front')
                            })
                          ], 2))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: _normalizeClass([
                  'relative tbody-tr grid grid-cols-base-table-tablet items-center w-full min-h-[52px]',
                  'xl:grid-cols-base-table-xl',
                  '2xl:grid-cols-base-table-2xl',
                  _ctx.hasPaddingLeft
                    ? _ctx.customPaddingLeft
                      ? _ctx.customPaddingLeft
                      : 'pl-6'
                    : null,
                  _ctx.customPaddingRight ? _ctx.customPaddingRight : null,
                  _ctx.customGap ? _ctx.customGap : null,
                  _ctx.rowsTableError && _ctx.rowsTableError[index]
                    ? '!bg-red-100'
                    : null,
                  _ctx.clickable &&
                    hasInfoFieldDesktop.value &&
                    !isVehicleSearchDisableClickRow(tableItem, 'rear')
                    ? 'group'
                    : null,
                  isVehicleSearchDisableClickRow(tableItem, 'rear')
                    ? 'pb-[44px]'
                    : null,
                ])
                      }, [
                        (isVehicleSearchDisableClickRow(tableItem, 'rear'))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t("BIKES-SUGGESTION")), 1))
                          : _createCommentVNode("", true),
                        (
                    _ctx.clickable &&
                      hasInfoFieldDesktop.value &&
                      !isVehicleSearchDisableClickRow(tableItem, 'rear')
                  )
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "hidden xl:block absolute w-full h-full click-area z-[1]",
                              onClick: ($event: any) => (onClickTableRow(tableItem, index, 'rear'))
                            }, null, 8, _hoisted_9))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(computedTableFields.value, (field, fieldIndex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `virtualTableBodyTd${index}${fieldIndex}${computedTableFields.value.length}`,
                            class: _normalizeClass([
                    'table-body-data flex items-center min-h-[52px]',
                    _ctx.tableBodyClass ? _ctx.tableBodyClass : 'text-sm',
                    field.value === 'favourite' || field.value === 'cart'
                      ? 'h-full justify-center'
                      : null,
                    field.colSpan ? field.colSpan : '',
                    field.value === 'cart' && showRowMoreInfoRear.value[index]
                      ? '-col-start-1 row-span-4'
                      : field.value === 'cart'
                        ? '-col-start-1 row-span-2'
                        : '',
                    field.value === 'favourite' && showRowMoreInfoRear.value[index]
                      ? 'col-start-1 row-span-4'
                      : field.value === 'favourite'
                        ? 'col-start-1 row-span-2'
                        : '',
                    field.isAction ? 'relative z-10' : null,
                    field.align,
                    field.flexJustify,
                    field.value,
                    _ctx.rowsTableError && _ctx.rowsTableError[index]
                      ? '!bg-red-100'
                      : null,
                  ])
                          }, [
                            (
                      [
                        'quantity',
                        'quantityRear',
                        'cart',
                        'cartRear',
                        'price',
                        'priceRear',
                        'info',
                        'infoRear',
                        'calculationBasisPrice',
                        'salePrice',
                        'purchasingPrice',
                        'reductionPrice',
                      ].includes(field.value) &&
                        isNoLongerProducedProduct(tableItem, 'rear')
                    )
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
                              : (
                      ['quantity', 'quantityRear'].includes(
                        field.value.toLowerCase()
                      ) &&
                        isCommentNoProduction(tableItem, 'rear') &&
                        isNoStock(tableItem, 'rear')
                    )
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [], 64))
                                : (
                      (isProduct88(tableItem, 'rear') ||
                        isProduct99(tableItem, 'rear')) &&
                        ['availability', 'availabilityRear'].includes(
                          field.value.toLowerCase()
                        )
                    )
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [], 64))
                                  : (
                      (isProduct88(tableItem, 'rear') ||
                        isProduct99(tableItem, 'rear')) &&
                        ['image', 'imageRear'].includes(field.value.toLowerCase())
                    )
                                    ? (_openBlock(), _createBlock(IconInformationTransparent, {
                                        key: 3,
                                        style: {"margin-left":"10px"}
                                      }))
                                    : (_ctx.$slots[`td(${field.value}Rear)`])
                                      ? _renderSlot(_ctx.$slots, `td(${field.value}Rear)`, {
                                          key: 4,
                                          item: tableItem,
                                          index: index,
                                          value: tableItem[field.value],
                                          toggleExpandRow: 
                      () => toggleTableRowExpand(tableItem, index, 'rear')
                    ,
                                          toggleRowMoreInfo: 
                      () => toggleRowMoreInfo(index, 'rear')
                    ,
                                          expandRowStatus: expandRowStatusRear.value[index],
                                          showRowMoreInfo: showRowMoreInfoRear.value[index]
                                        })
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                          _createTextVNode(_toDisplayString(tableItem[field.value]), 1)
                                        ], 64))
                          ], 2))
                        }), 128)),
                        (_unref(isTablet) && showRowMoreInfoRear.value[index])
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.tableFieldsTabletMoreInfo, (field, fieldIndex) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: `virtualTableBodyTdTabletMoreInfo${index}${fieldIndex}`,
                                class: _normalizeClass([
                      'table-body-data flex items-center h-[68px]',
                      _ctx.tableBodyClass ? _ctx.tableBodyClass : 'text-sm',
                      field.value === 'cart' ? 'h-full justify-center' : null,
                      field.colSpan ? field.colSpan : '',
                      field.isAction ? 'relative z-10' : null,
                      field.align,
                      field.flexJustify,
                      field.value,
                      _ctx.rowsTableError && _ctx.rowsTableError[index]
                        ? '!bg-red-100'
                        : null,
                    ])
                              }, [
                                _renderSlot(_ctx.$slots, `td(${field.value}TabletMoreRear)`, {
                                  item: tableItem,
                                  index: index,
                                  value: tableItem[field.value]
                                })
                              ], 2))
                            }), 128))
                          : _createCommentVNode("", true)
                      ], 2),
                      (expandRowStatusRear.value[index] || tableItem.isExpand)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass([
                  'table-expand relative z-10 min-h-[52px] z-[21]',
                  _ctx.expandColSpan,
                ])
                          }, [
                            _renderSlot(_ctx.$slots, "tdExpandRear", {
                              item: tableItem,
                              index: index,
                              closeExpandRow: () => closeTableRowExpand(index, 'rear')
                            })
                          ], 2))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_6))
                  }), 128)),
              (!_ctx.isLoading && _ctx.tableItems.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("NO-RESULT")), 1)
                  ]))
                : _createCommentVNode("", true),
              _renderSlot(_ctx.$slots, "bodyAppend")
            ])
          ]),
          _: 3
        }, 8, ["max-height", "is-loading", "is-page-end", "onNextPage"]))
      : (_ctx.scrollOptimize)
        ? (_openBlock(), _createBlock(DynamicScrollerTable, {
            key: 4,
            ref_key: "dynamicScrollerTableRef",
            ref: dynamicScrollerTableRef,
            items: _ctx.tableItems,
            "is-loading": _ctx.isLoading,
            "is-page-end": _ctx.isPageEnd,
            "max-height": _ctx.maxHeight,
            "key-field": _ctx.scrollOptimizeKeyField,
            "table-fields": _ctx.tableFields,
            "table-fields-tablet": _ctx.tableFieldsTablet,
            "table-fields-tablet-more-info": _ctx.tableFieldsTabletMoreInfo,
            "table-body-class": _ctx.tableBodyClass,
            "is-combination": _ctx.isCombination,
            clickable: _ctx.clickable,
            "expand-col-span": _ctx.expandColSpan,
            "has-padding-left": _ctx.hasPaddingLeft,
            "custom-padding-left": _ctx.customPaddingLeft,
            "custom-padding-right": _ctx.customPaddingRight,
            "custom-gap": _ctx.customGap,
            "rows-table-error": _ctx.rowsTableError,
            "is-vehicle-search": _ctx.isVehicleSearch,
            "show-all-field": _ctx.showAllField,
            "always-show-more-info": _ctx.alwaysShowMoreInfo,
            "is-init-open-show-more-info": _ctx.isInitOpenShowMoreInfo,
            inverse: _ctx.inverse,
            "combination-type": _ctx.combinationType,
            "has-info-field-desktop": hasInfoFieldDesktop.value,
            onNextPage: _unref(onNextPage),
            onRowClick: _cache[0] || (_cache[0] = (data) => emit('row-click', data)),
            onToggleTableRowExpand: _cache[1] || (_cache[1] = (data) => emit('toggle-table-row-expand', data)),
            onCloseTableRowExpand: _cache[2] || (_cache[2] = ($event: any) => (emit('close-table-row-expand'))),
            onToggleRowMoreInfo: _cache[3] || (_cache[3] = ($event: any) => (emit('toggle-row-more-info')))
          }, _createSlots({
            bodyPrepend: _withCtx(() => [
              _renderSlot(_ctx.$slots, "bodyPrepend")
            ]),
            bodyAppend: _withCtx(() => [
              _renderSlot(_ctx.$slots, "bodyAppend")
            ]),
            tdExpand: _withCtx((slotProps) => [
              _renderSlot(_ctx.$slots, "tdExpand", {
                item: slotProps.item,
                index: slotProps.index,
                closeExpandRow: slotProps.closeExpandRow
              })
            ]),
            tdExpandFront: _withCtx((slotProps) => [
              _renderSlot(_ctx.$slots, "tdExpandFront", {
                item: slotProps.item,
                index: slotProps.index,
                closeExpandRow: slotProps.closeExpandRow
              })
            ]),
            tdExpandRear: _withCtx((slotProps) => [
              _renderSlot(_ctx.$slots, "tdExpandRear", {
                item: slotProps.item,
                index: slotProps.index,
                closeExpandRow: slotProps.closeExpandRow
              })
            ]),
            "td(cart)": _withCtx((slotProps) => [
              _renderSlot(_ctx.$slots, "td(cart)", {
                item: slotProps.item,
                index: slotProps.index,
                value: slotProps.value
              })
            ]),
            _: 2
          }, [
            _renderList(_ctx.tableFields, (field) => {
              return {
                name: `td(${field.value})`,
                fn: _withCtx((slotProps) => [
                  _renderSlot(_ctx.$slots, `td(${field.value})`, {
                    item: slotProps.item,
                    index: slotProps.index,
                    value: slotProps.value,
                    toggleExpandRow: slotProps.toggleExpandRow,
                    toggleRowMoreInfo: slotProps.toggleRowMoreInfo,
                    expandRowStatus: slotProps.expandRowStatus,
                    showRowMoreInfo: slotProps.showRowMoreInfo
                  })
                ])
              }
            }),
            _renderList(_ctx.tableFieldsTablet, (field) => {
              return {
                name: `td(${field.value})`,
                fn: _withCtx((slotProps) => [
                  _renderSlot(_ctx.$slots, `td(${field.value})`, {
                    item: slotProps.item,
                    index: slotProps.index,
                    value: slotProps.value,
                    toggleExpandRow: slotProps.toggleExpandRow,
                    toggleRowMoreInfo: slotProps.toggleRowMoreInfo,
                    expandRowStatus: slotProps.expandRowStatus,
                    showRowMoreInfo: slotProps.showRowMoreInfo
                  })
                ])
              }
            }),
            _renderList(_ctx.tableFields, (field) => {
              return {
                name: `td(${field.value}Front)`,
                fn: _withCtx((slotProps) => [
                  _renderSlot(_ctx.$slots, `td(${field.value}Front)`, {
                    item: slotProps.item,
                    index: slotProps.index,
                    value: slotProps.value,
                    toggleExpandRow: slotProps.toggleExpandRow,
                    toggleRowMoreInfo: slotProps.toggleRowMoreInfo,
                    expandRowStatus: slotProps.expandRowStatus,
                    showRowMoreInfo: slotProps.showRowMoreInfo
                  })
                ])
              }
            }),
            _renderList(_ctx.tableFieldsTablet, (field) => {
              return {
                name: `td(${field.value}Front)`,
                fn: _withCtx((slotProps) => [
                  _renderSlot(_ctx.$slots, `td(${field.value}Front)`, {
                    item: slotProps.item,
                    index: slotProps.index,
                    value: slotProps.value,
                    toggleExpandRow: slotProps.toggleExpandRow,
                    toggleRowMoreInfo: slotProps.toggleRowMoreInfo,
                    expandRowStatus: slotProps.expandRowStatus,
                    showRowMoreInfo: slotProps.showRowMoreInfo
                  })
                ])
              }
            }),
            _renderList(_ctx.tableFields, (field) => {
              return {
                name: `td(${field.value}Rear)`,
                fn: _withCtx((slotProps) => [
                  _renderSlot(_ctx.$slots, `td(${field.value}Rear)`, {
                    item: slotProps.item,
                    index: slotProps.index,
                    value: slotProps.value,
                    toggleExpandRow: slotProps.toggleExpandRow,
                    toggleRowMoreInfo: slotProps.toggleRowMoreInfo,
                    expandRowStatus: slotProps.expandRowStatus,
                    showRowMoreInfo: slotProps.showRowMoreInfo
                  })
                ])
              }
            }),
            _renderList(_ctx.tableFieldsTablet, (field) => {
              return {
                name: `td(${field.value}Rear)`,
                fn: _withCtx((slotProps) => [
                  _renderSlot(_ctx.$slots, `td(${field.value}Rear)`, {
                    item: slotProps.item,
                    index: slotProps.index,
                    value: slotProps.value,
                    toggleExpandRow: slotProps.toggleExpandRow,
                    toggleRowMoreInfo: slotProps.toggleRowMoreInfo,
                    expandRowStatus: slotProps.expandRowStatus,
                    showRowMoreInfo: slotProps.showRowMoreInfo
                  })
                ])
              }
            }),
            _renderList(_ctx.tableFieldsTabletMoreInfo, (field) => {
              return {
                name: `td(${field.value}TabletMore)`,
                fn: _withCtx((slotProps) => [
                  _renderSlot(_ctx.$slots, `td(${field.value}TabletMore)`, {
                    item: slotProps.item,
                    index: slotProps.index,
                    value: slotProps.value
                  })
                ])
              }
            }),
            _renderList(_ctx.tableFieldsTabletMoreInfo, (field) => {
              return {
                name: `td(${field.value}TabletMoreFront)`,
                fn: _withCtx((slotProps) => [
                  _renderSlot(_ctx.$slots, `td(${field.value}TabletMoreFront)`, {
                    item: slotProps.item,
                    index: slotProps.index,
                    value: slotProps.value
                  })
                ])
              }
            }),
            _renderList(_ctx.tableFieldsTabletMoreInfo, (field) => {
              return {
                name: `td(${field.value}TabletMoreRear)`,
                fn: _withCtx((slotProps) => [
                  _renderSlot(_ctx.$slots, `td(${field.value}TabletMoreRear)`, {
                    item: slotProps.item,
                    index: slotProps.index,
                    value: slotProps.value
                  })
                ])
              }
            })
          ]), 1032, ["items", "is-loading", "is-page-end", "max-height", "key-field", "table-fields", "table-fields-tablet", "table-fields-tablet-more-info", "table-body-class", "is-combination", "clickable", "expand-col-span", "has-padding-left", "custom-padding-left", "custom-padding-right", "custom-gap", "rows-table-error", "is-vehicle-search", "show-all-field", "always-show-more-info", "is-init-open-show-more-info", "inverse", "combination-type", "has-info-field-desktop", "onNextPage"]))
        : (_openBlock(), _createElementBlock("div", {
            key: 5,
            class: "relative tbody-container",
            style: _normalizeStyle(
        _ctx.addToCartPopup
          ? {
            maxHeight: 'calc(70vh - 282px)',
            overflowY: 'auto',
          }
          : undefined
      )
          }, [
            _renderSlot(_ctx.$slots, "bodyPrepend"),
            _createVNode(_Transition, {
              mode: "out-in",
              "enter-active-class": "transition ease-out duration-100",
              "enter-from-class": "opacity-0",
              "enter-to-class": "opacity-100",
              "leave-active-class": "transition ease-in duration 100",
              "leave-from-class": "opacity-100",
              "leave-to-class": "opacity-0"
            }, {
              default: _withCtx(() => [
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (!_ctx.isCombination)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.tableItems, (tableItem, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `tableItem${index}`,
                    class: _normalizeClass([
            'relative tbody-tr grid grid-cols-base-table-tablet items-center w-full min-h-[52px] group hover:bg-zbr-primary-50',
            'xl:grid-cols-base-table-xl',
            '2xl:grid-cols-base-table-2xl',
            getRowClass(index),
            _ctx.hasPaddingLeft
              ? _ctx.customPaddingLeft
                ? _ctx.customPaddingLeft
                : 'pl-6'
              : null,
            _ctx.customPaddingRight ? _ctx.customPaddingRight : null,
            _ctx.customGap ? _ctx.customGap : null,
            _ctx.clickable && hasInfoFieldDesktop.value ? 'group' : null,
            _ctx.rowsTableError && _ctx.rowsTableError[index] ? '!bg-red-100' : null,
            tableItem.isPremium ? 'is-premium-tyre' : '',
          ])
                  }, [
                    (_ctx.clickable && hasInfoFieldDesktop.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "hidden xl:block absolute w-full h-full click-area z-[1]",
                          onClick: ($event: any) => (onClickTableRow(tableItem, index))
                        }, null, 8, _hoisted_12))
                      : _createCommentVNode("", true),
                    (_ctx.hasRowTitle && _unref(isDesktop))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass(['table-body-row-title row-start-1', _ctx.expandColSpan])
                        }, [
                          _renderSlot(_ctx.$slots, "tdRowTitle", {
                            item: tableItem,
                            index: index
                          })
                        ], 2))
                      : _createCommentVNode("", true),
                    (_ctx.hasRowTitleTablet && _unref(isTablet))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          class: _normalizeClass(['table-body-row-title row-start-1', _ctx.expandColSpan])
                        }, [
                          _renderSlot(_ctx.$slots, "tdRowTitleTablet", {
                            item: tableItem,
                            index: index
                          })
                        ], 2))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(computedTableFields.value, (field, fieldIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `virtualTableBodyTdDesktop${index}${fieldIndex}-${field.value}`,
                        class: _normalizeClass([
              'table-body-data flex items-center min-h-[52px] group-hover:bg-zbr-primary-50',
              _ctx.tableBodyClass ? _ctx.tableBodyClass : 'text-sm',
              field.value === 'cart' ? 'h-full justify-center' : null,
              field.isAction ? 'relative z-10' : null,
              getRowClass(index),
              field.flexJustify,
              field.align,
              field.value,
              _ctx.rowsTableError && _ctx.rowsTableError[index] ? '!bg-red-100' : null,
            ])
                      }, [
                        (
                [
                  'quantity',
                  'cart',
                  'price',
                  'info',
                  'calculationBasisPrice',
                  'salePrice',
                  'purchasingPrice',
                  'reductionPrice',
                ].includes(field.value) && isNoLongerProducedProduct(tableItem)
              )
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
                          : (
                ['quantity', 'cart'].includes(field.value.toLowerCase()) &&
                  isCommentNoProduction(tableItem) &&
                  tableItem.stock === 0
              )
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [], 64))
                            : (
                (isProduct88(tableItem) || isProduct99(tableItem)) &&
                  field.value.toLowerCase() === 'availability'
              )
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [], 64))
                              : (
                (isProduct88(tableItem) || isProduct99(tableItem)) &&
                  field.value.toLowerCase() === 'image'
              )
                                ? (_openBlock(), _createBlock(IconInformationTransparent, {
                                    key: 3,
                                    style: {"margin-left":"10px"}
                                  }))
                                : (_ctx.$slots[`td(${field.value})`])
                                  ? _renderSlot(_ctx.$slots, `td(${field.value})`, {
                                      key: 4,
                                      item: tableItem,
                                      index: index,
                                      value: tableItem[field.value],
                                      toggleExpandRow: () => toggleTableRowExpand(tableItem, index),
                                      toggleRowMoreInfo: () => toggleRowMoreInfo(index),
                                      expandRowStatus: expandRowStatus.value[index],
                                      showRowMoreInfo: showRowMoreInfo.value[index]
                                    })
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                      _createTextVNode(_toDisplayString(tableItem[field.value]), 1)
                                    ], 64))
                      ], 2))
                    }), 128)),
                    (_unref(isTablet) && showRowMoreInfo.value[index])
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.tableFieldsTabletMoreInfo, (field, fieldIndex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `virtualTableBodyTdTabletMoreInfo${index}${fieldIndex}`,
                            class: _normalizeClass([
                'table-body-data flex items-center h-[68px] border-zbr-gray-300 border-t',
                _ctx.tableBodyClass ? _ctx.tableBodyClass : 'text-sm',
                field.value === 'cart' ? 'h-full justify-center' : null,
                field.isAction ? 'relative z-10' : null,
                field.colSpan ? field.colSpan : '',
                field.align,
                field.flexJustify,
                field.value,
                _ctx.rowsTableError && _ctx.rowsTableError[index] ? '!bg-red-100' : null,
              ])
                          }, [
                            _renderSlot(_ctx.$slots, `td(${field.value}TabletMore)`, {
                              item: tableItem,
                              index: index,
                              value: tableItem[field.value]
                            })
                          ], 2))
                        }), 128))
                      : _createCommentVNode("", true),
                    (expandRowStatus.value[index] || tableItem.isExpand)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 4,
                          class: _normalizeClass([
              'table-expand relative z-10 row-end-auto min-h-[52px] z-[21]',
              _ctx.expandColSpan,
            ])
                        }, [
                          _renderSlot(_ctx.$slots, "tdExpand", {
                            item: tableItem,
                            index: index,
                            closeExpandRow: () => closeTableRowExpand(index)
                          })
                        ], 2))
                      : _createCommentVNode("", true)
                  ], 2))
                }), 128))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.tableItems, (tableItem, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `tableItemFront${index}`,
                    id: `group-tr-${index}`,
                    class: _normalizeClass([
              'relative hover:bg-zbr-primary-50',
              getRowClass(index),
              isPremiumCombinationTyres(tableItem) ? 'is-premium-tyre' : '',
            ])
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass([
                'relative tbody-tr grid grid-cols-base-table-tablet items-center w-full min-h-[52px]',
                'xl:grid-cols-base-table-xl',
                '2xl:grid-cols-base-table-2xl',
                _ctx.hasPaddingLeft
                  ? _ctx.customPaddingLeft
                    ? _ctx.customPaddingLeft
                    : 'pl-6'
                  : null,
                _ctx.customPaddingRight ? _ctx.customPaddingRight : null,
                _ctx.customGap ? _ctx.customGap : null,
                _ctx.clickable &&
                  hasInfoFieldDesktop.value &&
                  !isVehicleSearchDisableClickRow(tableItem, 'front')
                  ? 'group'
                  : null,
                _ctx.rowsTableError && _ctx.rowsTableError[index] ? '!bg-red-100' : null,
              ])
                    }, [
                      (
                  _ctx.clickable &&
                    hasInfoFieldDesktop.value &&
                    !isVehicleSearchDisableClickRow(tableItem, 'front')
                )
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "hidden xl:block absolute w-full h-full click-area z-[1]",
                            onClick: ($event: any) => (onClickTableRow(tableItem, index, 'front'))
                          }, null, 8, _hoisted_14))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(computedTableFields.value, (field, fieldIndex) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `virtualTableBodyTdNonScroll${index}${fieldIndex}`,
                          class: _normalizeClass([
                  'table-body-data flex items-center min-h-[52px]',
                  _ctx.tableBodyClass ? _ctx.tableBodyClass : 'text-sm',
                  field.value === 'favourite' || field.value === 'cart'
                    ? 'h-full justify-center'
                    : null,
                  field.colSpan ? field.colSpan : '',
                  field.value === 'cart' && showRowMoreInfoFront.value[index]
                    ? '-col-start-1 row-span-4'
                    : field.value === 'cart'
                      ? '-col-start-1 row-span-2 z-20'
                      : '',
                  field.value === 'favourite' && showRowMoreInfoFront.value[index]
                    ? 'col-start-1 row-span-4'
                    : field.value === 'favourite'
                      ? 'col-start-1 row-span-2'
                      : '',
                  field.isAction ? 'relative z-20' : null,
                  field.align,
                  field.flexJustify,
                  field.value,
                  _ctx.rowsTableError && _ctx.rowsTableError[index]
                    ? '!bg-red-100'
                    : null,
                ])
                        }, [
                          (
                    [
                      'quantity',
                      'price',
                      'info',
                      'quantityFront',
                      'priceFront',
                      'infoFront',
                      'calculationBasisPrice',
                      'salePrice',
                      'purchasingPrice',
                      'reductionPrice',
                    ].includes(field.value) &&
                      isNoLongerProducedProduct(tableItem, 'front')
                  )
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
                            : (
                    ['quantity', 'quantityFront'].includes(
                      field.value.toLowerCase()
                    ) &&
                      isCommentNoProduction(tableItem, 'front') &&
                      isNoStock(tableItem, 'front')
                  )
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [], 64))
                              : (
                    ['cart', 'cartFront'].includes(field.value.toLowerCase()) &&
                      isPairTyreShowCart(tableItem) &&
                      isNoLongerProducedProduct(tableItem, 'front') &&
                      isNoLongerProducedProduct(tableItem, 'rear')
                  )
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [], 64))
                                : (
                    ['cart', 'cartFront'].includes(field.value.toLowerCase()) &&
                      isPairTyreShowCart(tableItem) &&
                      isCommentNoProduction(tableItem, 'front') &&
                      isNoStock(tableItem, 'front') &&
                      isCommentNoProduction(tableItem, 'rear') &&
                      isNoStock(tableItem, 'rear')
                  )
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [], 64))
                                  : (
                    (isProduct88(tableItem, 'front') ||
                      isProduct99(tableItem, 'front')) &&
                      ['availability', 'availabilityFront'].includes(
                        field.value.toLowerCase()
                      )
                  )
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [], 64))
                                    : (
                    (isProduct88(tableItem, 'front') ||
                      isProduct99(tableItem, 'front')) &&
                      ['image', 'imageFront'].includes(field.value.toLowerCase())
                  )
                                      ? (_openBlock(), _createBlock(IconInformationTransparent, {
                                          key: 5,
                                          style: {"margin-left":"10px"}
                                        }))
                                      : (field.value === 'cart')
                                        ? _renderSlot(_ctx.$slots, "td(cart)", {
                                            key: 6,
                                            item: tableItem,
                                            index: index,
                                            value: tableItem['cart']
                                          })
                                        : (_ctx.$slots[`td(${field.value}Front)`])
                                          ? _renderSlot(_ctx.$slots, `td(${field.value}Front)`, {
                                              key: 7,
                                              item: tableItem,
                                              index: index,
                                              value: tableItem[field.value],
                                              toggleExpandRow: 
                    () => toggleTableRowExpand(tableItem, index, 'front')
                  ,
                                              toggleRowMoreInfo: 
                    () => toggleRowMoreInfo(index, 'front')
                  ,
                                              expandRowStatus: expandRowStatusFront.value[index],
                                              showRowMoreInfo: showRowMoreInfoFront.value[index]
                                            })
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                                              _createTextVNode(_toDisplayString(tableItem[field.value]), 1)
                                            ], 64))
                        ], 2))
                      }), 128)),
                      (_unref(isTablet) && showRowMoreInfoFront.value[index])
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.tableFieldsTabletMoreInfo, (field, fieldIndex) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: `virtualTableBodyTdTabletMoreFront${index}${fieldIndex}`,
                              class: _normalizeClass([
                    'table-body-data flex items-center h-[68px] border-zbr-gray-300 border-b',
                    _ctx.tableBodyClass ? _ctx.tableBodyClass : 'text-sm',
                    field.value === 'cart' ? 'h-full justify-center' : null,
                    field.colSpan ? field.colSpan : '',
                    field.isAction ? 'relative z-10' : null,
                    field.align,
                    field.flexJustify,
                    field.value,
                    _ctx.rowsTableError && _ctx.rowsTableError[index]
                      ? '!bg-red-100'
                      : null,
                  ])
                            }, [
                              _renderSlot(_ctx.$slots, `td(${field.value}TabletMoreFront)`, {
                                item: tableItem,
                                index: index,
                                value: tableItem[field.value]
                              })
                            ], 2))
                          }), 128))
                        : _createCommentVNode("", true)
                    ], 2),
                    (expandRowStatusFront.value[index] || tableItem.isExpand)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass([
                'table-expand relative z-10 min-h-[52px] z-[21]',
                _ctx.expandColSpan,
              ])
                        }, [
                          _renderSlot(_ctx.$slots, "tdExpandFront", {
                            item: tableItem,
                            index: index,
                            closeExpandRow: () => closeTableRowExpand(index, 'front')
                          })
                        ], 2))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: _normalizeClass([
                'relative tbody-tr grid grid-cols-base-table-tablet items-center w-full min-h-[52px]',
                'xl:grid-cols-base-table-xl',
                '2xl:grid-cols-base-table-2xl',
                _ctx.hasPaddingLeft
                  ? _ctx.customPaddingLeft
                    ? _ctx.customPaddingLeft
                    : 'pl-6'
                  : null,
                _ctx.customPaddingRight ? _ctx.customPaddingRight : null,
                _ctx.customGap ? _ctx.customGap : null,
                _ctx.rowsTableError && _ctx.rowsTableError[index] ? '!bg-red-100' : null,
                _ctx.clickable &&
                  hasInfoFieldDesktop.value &&
                  !isVehicleSearchDisableClickRow(tableItem, 'rear')
                  ? 'group'
                  : null,
                isVehicleSearchDisableClickRow(tableItem, 'rear')
                  ? 'pb-[44px]'
                  : null,
              ])
                    }, [
                      (isVehicleSearchDisableClickRow(tableItem, 'rear'))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.$t("BIKES-SUGGESTION")), 1))
                        : _createCommentVNode("", true),
                      (
                  _ctx.clickable &&
                    hasInfoFieldDesktop.value &&
                    !isVehicleSearchDisableClickRow(tableItem, 'rear')
                )
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "hidden xl:block absolute w-full h-full click-area z-[1]",
                            onClick: ($event: any) => (onClickTableRow(tableItem, index, 'rear'))
                          }, null, 8, _hoisted_16))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(computedTableFields.value, (field, fieldIndex) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `virtualTableBodyTd${index}${fieldIndex}${computedTableFields.value.length}`,
                          class: _normalizeClass([
                  'table-body-data flex items-center min-h-[52px]',
                  _ctx.tableBodyClass ? _ctx.tableBodyClass : 'text-sm',
                  field.value === 'favourite' || field.value === 'cart'
                    ? 'h-full justify-center'
                    : null,
                  field.colSpan ? field.colSpan : '',
                  field.value === 'cart' && showRowMoreInfoRear.value[index]
                    ? '-col-start-1 row-span-4'
                    : field.value === 'cart'
                      ? '-col-start-1 row-span-2'
                      : '',
                  field.value === 'favourite' && showRowMoreInfoRear.value[index]
                    ? 'col-start-1 row-span-4'
                    : field.value === 'favourite'
                      ? 'col-start-1 row-span-2'
                      : '',
                  field.isAction ? 'relative z-10' : null,
                  field.align,
                  field.flexJustify,
                  field.value,
                  _ctx.rowsTableError && _ctx.rowsTableError[index]
                    ? '!bg-red-100'
                    : null,
                ])
                        }, [
                          (
                    [
                      'quantity',
                      'quantityRear',
                      'cart',
                      'cartRear',
                      'price',
                      'priceRear',
                      'info',
                      'infoRear',
                      'calculationBasisPrice',
                      'salePrice',
                      'purchasingPrice',
                      'reductionPrice',
                    ].includes(field.value) &&
                      isNoLongerProducedProduct(tableItem, 'rear')
                  )
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
                            : (
                    ['quantity', 'quantityRear'].includes(
                      field.value.toLowerCase()
                    ) &&
                      isCommentNoProduction(tableItem, 'rear') &&
                      isNoStock(tableItem, 'rear')
                  )
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [], 64))
                              : (
                    (isProduct88(tableItem, 'rear') ||
                      isProduct99(tableItem, 'rear')) &&
                      ['availability', 'availabilityRear'].includes(
                        field.value.toLowerCase()
                      )
                  )
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [], 64))
                                : (
                    (isProduct88(tableItem, 'rear') ||
                      isProduct99(tableItem, 'rear')) &&
                      ['image', 'imageRear'].includes(field.value.toLowerCase())
                  )
                                  ? (_openBlock(), _createBlock(IconInformationTransparent, {
                                      key: 3,
                                      style: {"margin-left":"10px"}
                                    }))
                                  : (_ctx.$slots[`td(${field.value}Rear)`])
                                    ? _renderSlot(_ctx.$slots, `td(${field.value}Rear)`, {
                                        key: 4,
                                        item: tableItem,
                                        index: index,
                                        value: tableItem[field.value],
                                        toggleExpandRow: 
                    () => toggleTableRowExpand(tableItem, index, 'rear')
                  ,
                                        toggleRowMoreInfo: () => toggleRowMoreInfo(index, 'rear'),
                                        expandRowStatus: expandRowStatusRear.value[index],
                                        showRowMoreInfo: showRowMoreInfoRear.value[index]
                                      })
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                        _createTextVNode(_toDisplayString(tableItem[field.value]), 1)
                                      ], 64))
                        ], 2))
                      }), 128)),
                      (_unref(isTablet) && showRowMoreInfoRear.value[index])
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.tableFieldsTabletMoreInfo, (field, fieldIndex) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: `virtualTableBodyTdTabletMoreInfo${index}${fieldIndex}`,
                              class: _normalizeClass([
                    'table-body-data flex items-center h-[68px]',
                    _ctx.tableBodyClass ? _ctx.tableBodyClass : 'text-sm',
                    field.value === 'cart' ? 'h-full justify-center' : null,
                    field.colSpan ? field.colSpan : '',
                    field.isAction ? 'relative z-10' : null,
                    field.align,
                    field.flexJustify,
                    field.value,
                    _ctx.rowsTableError && _ctx.rowsTableError[index]
                      ? '!bg-red-100'
                      : null,
                  ])
                            }, [
                              _renderSlot(_ctx.$slots, `td(${field.value}TabletMoreRear)`, {
                                item: tableItem,
                                index: index,
                                value: tableItem[field.value]
                              })
                            ], 2))
                          }), 128))
                        : _createCommentVNode("", true)
                    ], 2),
                    (expandRowStatusRear.value[index] || tableItem.isExpand)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass([
                'table-expand relative z-10 min-h-[52px] z-[21]',
                _ctx.expandColSpan,
              ])
                        }, [
                          _renderSlot(_ctx.$slots, "tdExpandRear", {
                            item: tableItem,
                            index: index,
                            closeExpandRow: () => closeTableRowExpand(index, 'rear')
                          })
                        ], 2))
                      : _createCommentVNode("", true)
                  ], 10, _hoisted_13))
                }), 128)),
            (!_ctx.isLoading && _ctx.tableItems.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("NO-RESULT")), 1)
                ]))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "bodyAppend")
          ], 4))
  ], 6))
}
}

})